import { render } from "./views/TransactionClose.html?vue&type=template&id=6ef1a5bc&external"
import script from "./TransactionClose.vue?vue&type=script&lang=js"
export * from "./TransactionClose.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__